import { useStores } from "../stores/useStores";
import { capitalize } from "../utils/StringUtilities";
import WatsonApi from "../backends/WatsonApi";
import { getDistrict } from "../utils/SchoolBlocksUtilities";

export function useNewsTerraceBlockPromise() {
  const { organizationStore, userStore } = useStores();

  return new Promise(async (res) => {
    const orgsToFetch = [organizationStore.currentOrganization];

    // fetch current org data
    if (
      !["district", "school"].includes(
        organizationStore.currentOrganization.type,
      ) &&
      organizationStore.organization?.id
    ) {
      // fetch title org data
      orgsToFetch.push({
        ...organizationStore.organization,
        title: `${capitalize(organizationStore.organization.type)} News`,
      });
    } else if (organizationStore.currentOrganization.type === "school") {
      const district = getDistrict(organizationStore.organization);
      if (district.id !== organizationStore.currentOrganization.id) {
        // fetch district data
        orgsToFetch.push({
          ...district,
          title: "District News",
        });
      }
    }

    const promises: Promise<any>[] = [];
    const client = await WatsonApi();

    for (const org of orgsToFetch) {
      promises.push(
        new Promise(async (res) => {
          const result =
            await client.apis.organizations.organizations_schoolfeed_items_list(
              {
                organization_pk: org.id,
                organization_id: org.id,
                page_size: 8,
                news_or_third_party_media: true,
                published: userStore.isEditor ? undefined : true,
                expand: "organization",
              },
            );
          const parsed = JSON.parse(result.data);
          res({
            id: org.id,
            title: org.title,
            items: parsed.data,
            total: parsed.meta.total,
            is_more: parsed.meta.total > parsed.data.length,
            page_size: 8,
          });
        }),
      );
    }

    const results = await Promise.all(promises);
    res(
      results.reduce((acc, curr) => {
        acc[curr.id] = curr;
        return acc;
      }, {}),
    );
  });
}
